import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/user-settings/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/user-settings/profile', params, replace: true });
    },
});
